var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrimaryRiyal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15002_47595)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15002_47595",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 0H0.5V29H25.5V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15002_47595)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_15002_47595",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 29
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 0.529297H0.5V28.4704H25.5V0.529297Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_15002_47595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0571 25.2823C15.611 26.2715 15.3161 27.345 15.2031 28.4707L24.6439 26.4638C25.09 25.4749 25.3847 24.4012 25.4979 23.2754L16.0571 25.2823Z",
    fill: "#D08759"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.646 20.4512C25.0921 19.4622 25.387 18.3885 25.5 17.2628L18.1459 18.8268V15.8201L24.6458 14.4388C25.0919 13.4498 25.3868 12.3761 25.4998 11.2504L18.1457 12.8131V1.99998C17.0189 2.63268 16.0181 3.47488 15.2046 4.46831V13.4385L12.2634 14.0636V0.529297C11.1366 1.16178 10.1358 2.0042 9.3223 2.99763V14.6886L2.74149 16.087C2.29537 17.0759 2.00026 18.1497 1.88706 19.2754L9.3223 17.6953V21.4818L1.35399 23.1751C0.907867 24.164 0.612975 25.2377 0.5 26.3635L8.8406 24.591C9.51956 24.4498 10.1031 24.0484 10.4825 23.496L12.0121 21.2282C12.1709 20.9936 12.2634 20.7103 12.2634 20.4056V17.0702L15.2046 16.445V22.4585L24.646 20.4512Z",
    fill: "#D08759"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15002_47595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 29,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryRiyal);
export default __webpack_public_path__ + "static/media/primaryRiyal.fd4049afc69ba1bd449e862303a98f4b.svg";
export { ForwardRef as ReactComponent };